import {SELECT_PAGE} from './actionTypes';

export default function SelectPage() {
 return {type: SELECT_PAGE}
}
